import { ajax } from 'services/ajax';
import { map, switchMap } from 'rxjs/operators';
import { jsonHeaders$ } from './headers';
import { combineLatest } from 'rxjs';
import { memberId$ } from './subjects';
import { PortalBanner } from 'interfaces/PortalBanner';
import { PageResponse } from 'interfaces/api/PageResponse';

export const bannerService = {
    //TODO replace deprecated combineLatest
    get$: combineLatest(jsonHeaders$, memberId$).pipe(
        switchMap(([headers, memberId]) =>
            ajax<PageResponse<PortalBanner>>({
                method: 'GET',
                url: `api/banners`,
                headers,
            }),
        ),
        map((response) => response.response)
    ),
};
